export const cycles = (state = { data: [], selectedCycle: null }, action) => {
  switch (action.type) {
    case "SET_CYCLES":
      state["data"] = action.payload
      return state
    case "SET_SELECTED_CYCLE":
      state["selectedCycle"] = action.payload
      return state
    default:
      return state
  }
}
